export const checkboxColumnDef = {
    name: 'checkbox',
    minWidth: 50,
    priority: 1,
    isSortable: false,
    isLabelHidden: true,
    fixedSize: true,
};
export const leftDesktopPadding = 3;
//# sourceMappingURL=Shared.js.map